import { Portal } from "@mui/core";
import { Paper, Skeleton, styled } from "@mui/material";
import { StyledLinearProgress } from "components/loader/StyledLinearProgress";
import { PaddedPaper } from "components/surfaces/PaddedPaper";

interface Props {
  footerRef: HTMLDivElement;
  mapOverlayContainer: HTMLDivElement;
}

export function DrawMeasureAreaSkeleton(props: Props) {
  const { footerRef, mapOverlayContainer } = props;

  return (
    <StyledPaddedPaper padding={6}>
      <Skeleton />
      <Skeleton />
      <Skeleton height={50} />
      <Portal container={footerRef}>
        <StyledPaper className="footer" elevation={0}>
          <Skeleton width={200} height={20} />
          <Skeleton width={100} height={40} />
        </StyledPaper>
      </Portal>
      <Portal container={mapOverlayContainer}>
        <StyledLinearProgress />
      </Portal>
    </StyledPaddedPaper>
  );
}

const StyledPaddedPaper = styled(PaddedPaper)`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: ${({ theme }) => theme.spacing(2)};
  .MuiSkeleton-root {
    transform: unset;
    transform-origin: unset;
  }

  .footer {
  }
`;

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  .MuiSkeleton-root {
    transform: unset;
    transform-origin: unset;
  }
`;
